var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test_detail_form"},[_c('div',{staticClass:"row"},[[_c('operation-table',{attrs:{"data":_vm.resultList,"col-configs":_vm.colConfigs}})],_vm._v(" "),_c('div')],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68298c6a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/KnowledgeGraph/_components/TestResultPop.vue
// module id = null
// module chunks = 